// import React, { useEffect, useState } from "react";
// import API from "../services/api";
// import "./manageAgent.css";

// function ManageAgentPage() {
//   const [agents, setAgents] = useState([]);
//   const [selected, setSelected] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [view, setView] = useState("active"); // 🔥 active / inactive
//   const role = localStorage.getItem("role"); // ✅ ADD

//   useEffect(() => {
//     fetchAgents();
//   }, []);

//   const fetchAgents = async () => {
//     try {
//       const res = await API.get("/agents/");
//       setAgents(res.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // 🔍 FILTER
//   const filteredAgents = agents.filter((a) => {
//     const matchSearch = a.mail_id?.toLowerCase().includes(search.toLowerCase());
//     const matchView = view === "active" ? a.is_active : !a.is_active;
//     return matchSearch && matchView;
//   });

//   // ✅ SELECT
//   const handleSelect = (id) => {
//     if (role === "bhr") return; // ❌ BLOCK BOH
//     if (selected.includes(id)) {
//       setSelected(selected.filter((i) => i !== id));
//     } else {
//       setSelected([...selected, id]);
//     }
//   };

//   const handleSelectAll = () => {
//     if (role === "bhr") return; // ❌ BLOCK BOH
//     if (selected.length === filteredAgents.length) {
//       setSelected([]);
//     } else {
//       setSelected(filteredAgents.map((a) => a.id));
//     }
//   };

//   // 🔥 BULK ACTION
//   const handleAction = async (type) => {
//     if (role === "bhr") return; // ❌ BLOCK BOH

//     if (selected.length === 0) {
//       alert("Select at least one agent");
//       return;
//     }

//     try {
//       setLoading(true);

//       await API.post("/agents/bulk-status", {
//         agent_ids: selected,
//         action: type,
//       });

//       fetchAgents();
//       setSelected([]);

//     } catch (err) {
//       alert("❌ Failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔥 SINGLE REACTIVATE
//   const handleSingleActivate = async (id) => {
//     if (role === "bhr") return; // ❌ BLOCK BOH

//     await API.post("/agents/bulk-status", {
//       agent_ids: [id],
//       action: "activate",
//     });

//     fetchAgents();
//   };

//   return (
//     <div className="manage-container">

//       {/* HEADER */}
//       <div className="header">
//         <h1>👥 Manage Agents</h1>
//         <p>Activate / Deactivate agents</p>
//       </div>

//       {/* 🔥 TOGGLE VIEW */}
//       <div className="toggle-bar">
//         <button
//           className={view === "active" ? "active-tab" : ""}
//           onClick={() => {
//             setView("active");
//             setSelected([]);
//           }}
//         >
//           🟢 Active
//         </button>

//         <button
//           className={view === "inactive" ? "active-tab" : ""}
//           onClick={() => {
//             setView("inactive");
//             setSelected([]);
//           }}
//         >
//           🔴 Deactivated
//         </button>
//       </div>

//       {/* SEARCH */}
//       <div className="search-box">
//         <input
//           type="text"
//           placeholder="Search by email..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* ACTION BAR */}
//       <div className="action-bar">

//         <label>
//           <input
//             type="checkbox"
//             onChange={handleSelectAll}
//             checked={
//               selected.length === filteredAgents.length &&
//               filteredAgents.length > 0
//             }
//             disabled={role === "bhr"} // ✅ disable select
//           />
//           Select All
//         </label>

//         <span className="count">Selected: {selected.length}</span>

//         {/* ❌ ACTIONS DISABLED FOR BOH */}
//         {role !== "bhr" && (
//           <>
//             {view === "active" && (
//               <button
//                 className="btn deactivate"
//                 onClick={() => handleAction("deactivate")}
//                 disabled={loading}
//               >
//                 ⛔ Deactivate
//               </button>
//             )}

//             {view === "inactive" && (
//               <button
//                 className="btn activate"
//                 onClick={() => handleAction("activate")}
//                 disabled={loading}
//               >
//                 ✅ Activate
//               </button>
//             )}
//           </>
//         )}

//         {/* ✅ READ ONLY MESSAGE */}
//         {role === "bhr" && (
//           <span style={{ color: "red", marginLeft: "10px" }}>
//             🔒 Read-only access
//           </span>
//         )}

//       </div>

//       {/* TABLE */}
//       <div className="table-container">
//         <table>
//           <thead>
//             <tr>
//               <th></th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Status</th>
//               {view === "inactive" && <th>Action</th>}
//             </tr>
//           </thead>

//           <tbody>
//             {filteredAgents.map((agent) => (
//               <tr key={agent.id}>

//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selected.includes(agent.id)}
//                     onChange={() => handleSelect(agent.id)}
//                     disabled={role === "bhr"} // ✅ BLOCK ROW SELECT
//                   />
//                 </td>

//                 <td>{agent.name_as_per_pan}</td>
//                 <td>{agent.mail_id}</td>

//                 <td>
//                   <span className={`status ${agent.is_active ? "active" : "inactive"}`}>
//                     {agent.is_active ? "Active" : "Inactive"}
//                   </span>
//                 </td>

//                 {view === "inactive" && (
//                   <td>
//                     {role !== "bhr" ? (
//                       <button
//                         className="btn small activate"
//                         onClick={() => handleSingleActivate(agent.id)}
//                       >
//                         🔄 Reactivate
//                       </button>
//                     ) : (
//                       <span style={{ color: "gray" }}>View Only</span>
//                     )}
//                   </td>
//                 )}

//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//     </div>
//   );
// }

// export default ManageAgentPage;




import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function ManageAgentPage() {
  const [agents, setAgents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("active"); // 🔥 active / inactive
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  
  const navigate = useNavigate();
  const role = localStorage.getItem("role"); // ✅ RBAC

  // 🖱️ Mouse Tracking for Background Effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      const res = await API.get("/agents/");
      setAgents(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔍 FILTER Logic
  const filteredAgents = agents.filter((a) => {
    const matchSearch = (a.mail_id || "").toLowerCase().includes(search.toLowerCase()) || 
                        (a.name_as_per_pan || "").toLowerCase().includes(search.toLowerCase());
    const matchView = view === "active" ? a.is_active : !a.is_active;
    return matchSearch && matchView;
  });

  // ✅ SELECT Logic
  const handleSelect = (id) => {
    if (role === "bhr") return; // ❌ BLOCK BOH
    if (selected.includes(id)) {
      setSelected(selected.filter((i) => i !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const handleSelectAll = () => {
    if (role === "bhr") return; // ❌ BLOCK BOH
    if (selected.length === filteredAgents.length && filteredAgents.length > 0) {
      setSelected([]);
    } else {
      setSelected(filteredAgents.map((a) => a.id));
    }
  };

  // 🔥 BULK ACTION Logic
  const handleAction = async (type) => {
    if (role === "bhr") return; // ❌ BLOCK BOH
    if (selected.length === 0) {
      alert("Select at least one agent");
      return;
    }

    try {
      setLoading(true);
      await API.post("/agents/bulk-status", {
        agent_ids: selected,
        action: type,
      });
      alert(`✅ Agents ${type === 'activate' ? 'Activated' : 'Deactivated'} Successfully`);
      fetchAgents();
      setSelected([]);
    } catch (err) {
      alert("❌ Operation Failed");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 SINGLE REACTIVATE Logic
  const handleSingleActivate = async (id) => {
    if (role === "bhr") return; // ❌ BLOCK BOH
    try {
      await API.post("/agents/bulk-status", {
        agent_ids: [id],
        action: "activate",
      });
      fetchAgents();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="manage-page-wrapper">
      <style>{`
        .manage-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 60px 20px 120px 20px;
          position: relative;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(239, 68, 68, 0.05) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .container {
          max-width: 1100px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        /* --- HEADER & TOGGLE --- */
        .header { text-align: center; margin-bottom: 30px; }
        .header h1 {
          font-size: 36px; font-weight: 800; letter-spacing: -1.5px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }

        .toggle-bar {
          display: flex;
          background: rgba(255, 255, 255, 0.03);
          padding: 6px;
          border-radius: 16px;
          width: fit-content;
          margin: 30px auto;
          border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .toggle-bar button {
          padding: 10px 25px;
          border-radius: 12px;
          border: none;
          background: transparent;
          color: #64748b;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
          font-size: 14px;
        }

        .toggle-bar button.active-tab {
          background: rgba(255, 255, 255, 0.08);
          color: white;
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
        }

        /* --- SEARCH & ACTIONS --- */
        .controls {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          background: rgba(255, 255, 255, 0.02);
          padding: 20px;
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.05);
        }

        .search-box input {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          padding: 12px 20px;
          border-radius: 14px;
          color: white;
          width: 280px;
          outline: none;
        }

        .action-bar { display: flex; align-items: center; gap: 20px; }

        .btn {
          padding: 12px 24px;
          border-radius: 12px;
          font-weight: 800;
          cursor: pointer;
          border: none;
          transition: 0.3s;
          font-size: 14px;
        }

        .btn.deactivate { background: #ef4444; color: white; }
        .btn.activate { background: #22c55e; color: white; }
        .btn:disabled { opacity: 0.3; cursor: not-allowed; }
        .btn:hover:not(:disabled) { transform: translateY(-2px); filter: brightness(1.1); }

        .btn.small { padding: 6px 12px; font-size: 11px; }

        /* --- TABLE --- */
        .table-container {
          background: rgba(255, 255, 255, 0.02);
          border-radius: 28px;
          border: 1px solid rgba(255, 255, 255, 0.08);
          overflow: hidden;
          backdrop-filter: blur(20px);
        }

        table { width: 100%; border-collapse: collapse; text-align: left; }
        th { padding: 20px; background: rgba(255,255,255,0.03); color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 1px; }
        td { padding: 18px 20px; border-bottom: 1px solid rgba(255,255,255,0.03); font-size: 14px; }

        .status-pill {
          padding: 4px 10px; border-radius: 8px; font-size: 11px; font-weight: 700; text-transform: uppercase;
        }
        .status-pill.active { background: rgba(34, 197, 94, 0.1); color: #22c55e; }
        .status-pill.inactive { background: rgba(239, 68, 68, 0.1); color: #ef4444; }

        /* 📍 BACK BUTTON */
        .back-btn-fixed {
          position: fixed; bottom: 30px; left: 30px;
           width:15rem;
          background: rgba(255, 255, 255, 0.05); backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.1); color: #94a3b8;
          padding: 14px 24px; border-radius: 16px; cursor: pointer; font-weight: 700;
          z-index: 100; transition: 0.3s; display: flex; align-items: center; gap: 10px;
        }
        .back-btn-fixed:hover { background: rgba(255, 255, 255, 0.1); color: white; transform: translateX(6px); }

        input[type="checkbox"] { accent-color: #ef4444; width: 18px; height: 18px; cursor: pointer; }
      `}</style>

      <div className="spotlight"></div>

      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> Back to Dashboard
      </button>

      <div className="container">
        <div className="header">
          <h1>👥 Manage Agents</h1>
          <p>Control agent access and operational status</p>
        </div>

        <div className="toggle-bar">
          <button 
            className={view === "active" ? "active-tab" : ""} 
            onClick={() => { setView("active"); setSelected([]); }}
          >
            🟢 Active
          </button>
          <button 
            className={view === "inactive" ? "active-tab" : ""} 
            onClick={() => { setView("inactive"); setSelected([]); }}
          >
            🔴 Deactivated
          </button>
        </div>

        <div className="controls">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by name or email..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="action-bar">
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: role === 'bhr' ? '#475569' : 'white' }}>
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={selected.length === filteredAgents.length && filteredAgents.length > 0}
                disabled={role === "bhr"}
              />
              Select All
            </label>
            <span style={{ color: '#475569' }}>|</span>
            <span style={{ fontWeight: '700', fontSize: '14px', color: selected.length > 0 ? '#ef4444' : '#64748b' }}>
              {selected.length} Selected
            </span>

            {role !== "bhr" ? (
              view === "active" ? (
                <button className="btn deactivate" onClick={() => handleAction("deactivate")} disabled={loading || selected.length === 0}>
                  ⛔ Deactivate
                </button>
              ) : (
                <button className="btn activate" onClick={() => handleAction("activate")} disabled={loading || selected.length === 0}>
                  ✅ Activate
                </button>
              )
            ) : (
              <span style={{ color: "#ef4444", fontSize: "12px", fontWeight: "700" }}>🔒 READ-ONLY</span>
            )}
          </div>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th style={{ width: '50px' }}></th>
                <th>Name</th>
                <th>Email Address</th>
                <th>Status</th>
                {view === "inactive" && <th style={{ textAlign: 'right' }}>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {filteredAgents.map((agent) => (
                <tr key={agent.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selected.includes(agent.id)}
                      onChange={() => handleSelect(agent.id)}
                      disabled={role === "bhr"}
                    />
                  </td>
                  <td style={{ fontWeight: '600' }}>{agent.name_as_per_pan}</td>
                  <td style={{ color: '#94a3b8' }}>{agent.mail_id}</td>
                  <td>
                    <span className={`status-pill ${agent.is_active ? "active" : "inactive"}`}>
                      {agent.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  {view === "inactive" && (
                    <td style={{ textAlign: 'right' }}>
                      {role !== "bhr" ? (
                        <button className="btn small activate" onClick={() => handleSingleActivate(agent.id)}>
                          🔄 Reactivate
                        </button>
                      ) : (
                        <span style={{ color: "#475569", fontSize: '12px' }}>View Only</span>
                      )}
                    </td>
                  )}
                </tr>
              ))}
              {filteredAgents.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#64748b' }}>
                    No {view} agents found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ManageAgentPage;



